<div class="home" data-testid="guineabissau-sesap-home-container">


  <div class="hero">
    <div class="photo-pane">
      <div class="photo"></div>
    </div>
    <div class="info-pane">
      <div class="info-header">
        <h2>{{ 'home-guineabissau-sesap.country-heading' | translate }}</h2>
        <img
          class="sesap-logo"
          src="/assets/images/guineabissau-sesap/sesap-logo.png"
          alt="SESAP"
        />
      </div>

      <p class="intro">{{ 'home-guineabissau-sesap.intro-1' | translate }}</p>
      <p class="intro">{{ 'home-guineabissau-sesap.intro-2' | translate }}</p>
    </div>
  </div>


  <div class="bottom-box">
    <div class="box-left"></div>
    <div class="box-right">
      <h4>{{ 'home-guineabissau-sesap.cta-prompt' | translate }}</h4>
      <button class="btn btn-primary">
        <a [routerLink]="['../finance/programs']"
        >{{ 'home-guineabissau-sesap.cta-button' | translate }}</a>
      </button>
    </div>
  </div>

</div>
